import React from 'react'
import cx from 'classnames'
import { Box } from 'components/layout/Box/Box'
import next from 'assets/icons/next.svg'
import { t } from 'ttag'
import introStyles from '../IntroPage/IntroPage.module.scss'
import { getPersonality } from 'components/modals/TestsReportModal/tabs/helpers'
import gmaStyles from '../GMA/GMA.module.scss'

import { Scale } from 'components/shared/DoubleEndedScale/Scale'
import styles from './Personality.module.scss'
import reportStyles from '../../Report.module.scss'

export const PersonalityOverview = ({
  scores,
  language,
  factors,
  isCandidate = false,
}) => {
  const traits = factors.map(({ factor, label, id }) => ({
    id,
    label,
    score: Math.round(scores[factor] * 100),
  }))

  const personalityDescriptions = getPersonality(language, isCandidate)

  return (
    <Box
      className={reportStyles.containerWhite}
      direction="column"
      id="report"
      data-testid="report"
    >
      <div className={cx(introStyles.header, introStyles.headerPadding)}>
        <div className={introStyles.name}>{t`Personality report`}</div>
      </div>
      <div className={gmaStyles.paragraph}>{personalityDescriptions[0]}</div>
      <br />
      <div className={gmaStyles.paragraphTitle}>
        {t`Interpreting the Results`}
      </div>
      <br />
      <div className={gmaStyles.paragraph}>{personalityDescriptions[1]}</div>
      <br />
      <div className={gmaStyles.paragraph}>{personalityDescriptions[2]}</div>

      <div className={styles.traits}>
        {traits.map(({ label, score, id }) => {
          return (
            <div className={styles.traitScale} key={id}>
              <div className={styles.traitScaleLabel}>{label}</div>
              <div className={styles.scale}>
                <Scale
                  scores={[{ score, id: 0 }]}
                  withHighlight={false}
                  single
                />
              </div>
            </div>
          )
        })}
      </div>

      <div className={reportStyles.next}>
        <img src={next} alt="next" />
      </div>
    </Box>
  )
}
